import { requestEnvelope } from './client'
import { deviceDistItemSchema, deviceSchema, nullableArray, type Device, type DeviceDistItem } from './schemas'

export async function listDevices(): Promise<Device[]> {
  return requestEnvelope('/devices', nullableArray(deviceSchema))
}

export async function getDeviceDistribution(): Promise<DeviceDistItem[]> {
  return requestEnvelope('/devices/distribution', nullableArray(deviceDistItemSchema))
}
